import API_BASE from "../../../config";

export function authHeaders() {
  let user = null;
  try {
    user = JSON.parse(
      sessionStorage.getItem("user") || localStorage.getItem("user") || "null"
    );
  } catch { /* ignore */ }
  return {
    "X-User-Role":  user?.role     || "",
    "X-Username":   user?.username || "",
    ...(user?.linkedEntityId != null
      ? { "X-Linked-Entity-Id": String(user.linkedEntityId) } : {}),
    ...(user?.linkedEntityType
      ? { "X-Linked-Entity-Type": user.linkedEntityType } : {}),
  };
}

export function empName(emp) {
  if (!emp) return null;
  return [emp.firstName, emp.middleName, emp.lastName].filter(Boolean).join(" ");
}

export function avatarColor(seed) {
  const COLORS = ["#5a4e3a","#3a4e4a","#4a3a5a","#4e4a3a","#3a4a5a","#5a3a3a","#3a5a3a"];
  let h = 0;
  for (let i = 0; i < (seed || "").length; i++)
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
}

export function initials(first, last) {
  return ((last?.[0] ?? "") + (first?.[0] ?? "")).toUpperCase() || "?";
}

export function photoSrc(photoUrl) {
  if (!photoUrl) return null;
  if (/^https?:\/\//i.test(photoUrl)) return photoUrl;
  return `${API_BASE}${photoUrl.startsWith("/") ? "" : "/"}${photoUrl}`;
}

export function fmtDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric",
    hour: "numeric", minute: "2-digit",
  });
}
